import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Footer from '../components/footer';
import backgroundImage from '../assets/background.png';
import '../css/pages_styles.css';

const MC_Poster = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [sidebarExpanded, setSidebarExpanded] = useState(true);

    // 偵測螢幕大小
    useEffect(() => {
        const checkScreenSize = () => {
            const width = window.innerWidth;
            setIsMobile(width <= 768);
        };

        // 初始檢查
        checkScreenSize();

        // 監聽視窗大小變化
        window.addEventListener('resize', checkScreenSize);
        
        // 清理事件監聽器
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    // 監聽 sidebar 狀態變化的函數
    const handleSidebarToggle = (isExpanded) => {
        setSidebarExpanded(isExpanded);
    };

    // 第一場次 MC 海報資料 - 2025/08/25 10:00-10:50
    const session1MCData = [
        { posterNum: 1, mcId: 6, title: "VoiceTalk：自動化語音控制流程整合 IoTtalk 之系統設計" },
        { posterNum: 2, mcId: 9, title: "具可擴展性與安全性的列車控制通訊架構設計" },
        { posterNum: 3, mcId: 11, title: "基於深度學習的中文修辭手法識別" },
        { posterNum: 4, mcId: 13, title: "AI及3D建模於肺癌CT輔助診斷之應用" },
        { posterNum: 5, mcId: 15, title: "基於軟體定義網路使用李亞普諾夫定理之P4交換器實現緩衝區膨脹之抑制" },
        { posterNum: 6, mcId: 19, title: "基於 Scitags 的機構內部資料外流之防護機制" },
        { posterNum: 7, mcId: 21, title: "基於大型語言模型的Cisco網路設備自動化配置與管理" },
        { posterNum: 8, mcId: 22, title: "E-Cart智能跟隨載具" },
        { posterNum: 9, mcId: 23, title: "機器學習與人工智慧於智慧醫療決策支援系統之應用" },
        { posterNum: 10, mcId: 25, title: "聯邦學習架構下聚合演算法於流量分類應用中的影響" }
    ];

    // 第二場次 MC 海報資料 - 2025/08/25 15:20-16:10
    const session2MCData = [
        { posterNum: 1, mcId: 68, title: "以優先佇列改善零信任工業物聯網系統效率" },
        { posterNum: 2, mcId: 72, title: "對抗樣本技術應用於社交媒體之影像隱私保護研究與平台開發" },
        { posterNum: 3, mcId: 67, title: "基於深度強化學習之工業物聯網服務功能鏈最佳化配置" },
        { posterNum: 4, mcId: 79, title: "即時多攝影機行人行為理解與搜尋系統" },
        { posterNum: 5, mcId: 4, title: "應用於定時器檢查點的間歇式系統資料壓縮方法" },
        { posterNum: 6, mcId: 20, title: "邊緣韌性服務代理：基於邊緣 AI 建構 5G-NR與Wi-Fi 6 異質MEC網路IoT應用框架" },
        { posterNum: 7, mcId: 60, title: "雙層強化學習架構於無人機回程網路多類型服務切片資源最佳化" },
        { posterNum: 8, mcId: 59, title: "空地一體化異質網路下D2D通訊之能源效率與公平性聯合優化" },
        { posterNum: 9, mcId: 35, title: "智慧居家安全的個人位置追蹤系統" }
    ];

    // 第三場次 MC 海報資料 - 2025/08/26 09:30-10:20
    const session3MCData = [
        { posterNum: 1, mcId: 26, title: "樣本數及取樣方法的對於網路流量分類效能的影響" },
        { posterNum: 2, mcId: 27, title: "淺談海港5G基地台設置規劃與評估" },
        { posterNum: 3, mcId: 32, title: "Adaptive Lane-Level Navigation for Emergency Service Optimization Based on the Internet of Vehicles" },
        { posterNum: 4, mcId: 37, title: "基於MATD3電動公車充電排程最佳化方法" },
        { posterNum: 5, mcId: 38, title: "智慧化個人旅遊規劃之行動App應用設計與開發： 以澎湖旅遊為展示例" },
        { posterNum: 6, mcId: 42, title: "無線網路異質節點中基於協同深度強化學習的自適應競爭機制" }
    ];

    // 第四場次 MC 海報資料 - 2025/08/26 10:30-11:20
    const session4MCData = [
        { posterNum: 1, mcId: 63, title: "A Smart Presentation System Utilizing MediaPipe Hand Gesture Recognition and LLM Voice Analysis" },
        { posterNum: 2, mcId: 65, title: "智慧麻將輔助辨識系統(I-MARS)" },
        { posterNum: 3, mcId: 74, title: "Development of Cloud Platform for Smart Mobile Vehicle Scheduling and Management" },
        { posterNum: 4, mcId: 47, title: "RegDNN：準確且降低成本的FTM與RSSI混和指紋室內定位" },
        { posterNum: 5, mcId: 54, title: "針對網路服務功能鏈線上部署的碳排放與延遲整合最佳化" },
        { posterNum: 6, mcId: 61, title: "基於多度量 A* 與改進貪婪恢復的車載網路混合源路由" }
    ];

    return (
        <div style={{ display: 'flex', position: 'relative' }}>
            <Sidebar onToggle={handleSidebarToggle} />
            <div 
                className="main-content"
                style={{
                    marginLeft: isMobile ? '0' : (sidebarExpanded ? '250px' : '0')
                }}
            >
                <div className="container">
                    <header 
                        className="header"
                        style={{backgroundImage: `url(${backgroundImage})`}}
                        >
                        <h1 className="title">MC海報編號</h1>
                    </header>

                    {/* 第一場次 */}
                    <section className={`section ${isMobile ? 'section-mobile' : ''}`}>
                        <div className="subtitle">
                            <strong>Poster 論文研究成果發表 I (亞歷山大廳)</strong>
                        </div>
                        <div style={{ 
                            fontSize: '1em', 
                            color: '#666', 
                            marginBottom: '20px',
                            textAlign: 'center'
                        }}>
                            時間：10:00-10:50 | 日期：2025/08/25
                        </div>
                        
                        <div className="table-container">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="th" style={{ width: '100px' }}>海報編號</th>
                                        <th className="th" style={{ width: '80px' }}>MC - ID</th>
                                        <th className="th">論文標題</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {session1MCData.map((item, index) => (
                                        <tr key={index}>
                                            <td className="td" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                Post {item.posterNum}
                                            </td>
                                            <td className="td" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                MC - {item.mcId}
                                            </td>
                                            <td className="td" style={{ textAlign: 'left', padding: '12px 15px' }}>
                                                {item.title}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </section>

                    {/* 第二場次 */}
                    <section className={`section ${isMobile ? 'section-mobile' : ''}`}>
                        <div className="subtitle">
                            <strong>Poster 論文研究成果發表 II (亞歷山大廳)</strong>
                        </div>
                        <div style={{ 
                            fontSize: '1em', 
                            color: '#666', 
                            marginBottom: '20px',
                            textAlign: 'center'
                        }}>
                            時間：15:20-16:10 | 日期：2025/08/25
                        </div>
                        
                        <div className="table-container">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="th" style={{ width: '100px' }}>海報編號</th>
                                        <th className="th" style={{ width: '80px' }}>MC - ID</th>
                                        <th className="th">論文標題</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {session2MCData.map((item, index) => (
                                        <tr key={index}>
                                            <td className="td" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                Post {item.posterNum}
                                            </td>
                                            <td className="td" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                MC - {item.mcId}
                                            </td>
                                            <td className="td" style={{ textAlign: 'left', padding: '12px 15px' }}>
                                                {item.title}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </section>

                    {/* 第三場次 */}
                    <section className={`section ${isMobile ? 'section-mobile' : ''}`}>
                        <div className="subtitle">
                            <strong>Poster 論文研究成果發表 III (亞歷山大廳)</strong>
                        </div>
                        <div style={{ 
                            fontSize: '1em', 
                            color: '#666', 
                            marginBottom: '20px',
                            textAlign: 'center'
                        }}>
                            時間：09:30-10:20 | 日期：2025/08/26
                        </div>
                        
                        <div className="table-container">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="th" style={{ width: '100px' }}>海報編號</th>
                                        <th className="th" style={{ width: '80px' }}>MC - ID</th>
                                        <th className="th">論文標題</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {session3MCData.map((item, index) => (
                                        <tr key={index}>
                                            <td className="td" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                Post {item.posterNum}
                                            </td>
                                            <td className="td" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                MC - {item.mcId}
                                            </td>
                                            <td className="td" style={{ textAlign: 'left', padding: '12px 15px' }}>
                                                {item.title}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </section>

                    {/* 第四場次 */}
                    <section className={`section ${isMobile ? 'section-mobile' : ''}`}>
                        <div className="subtitle">
                            <strong>Poster 論文研究成果發表 IV (亞歷山大廳)</strong>
                        </div>
                        <div style={{ 
                            fontSize: '1em', 
                            color: '#666', 
                            marginBottom: '20px',
                            textAlign: 'center'
                        }}>
                            時間：10:30-11:20 | 日期：2025/08/26
                        </div>
                        
                        <div className="table-container">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="th" style={{ width: '100px' }}>海報編號</th>
                                        <th className="th" style={{ width: '80px' }}>MC - ID</th>
                                        <th className="th">論文標題</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {session4MCData.map((item, index) => (
                                        <tr key={index}>
                                            <td className="td" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                Post {item.posterNum}
                                            </td>
                                            <td className="td" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                MC - {item.mcId}
                                            </td>
                                            <td className="td" style={{ textAlign: 'left', padding: '12px 15px' }}>
                                                {item.title}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </section>

                    <Footer/>
                </div>
            </div>
        </div>
    );
};

export default MC_Poster;